import { interval } from '../home/benefit-tabs';

export function systemComponentsTabs() {
  const $components = $('.system-components');
  if (!$components || $components.length === 0) return;

  const $nav = $components.find('.system-components-tab-navigation');
  const $tabs = $components.find('.system-components-tab-container');
  const length = $tabs.find('.system-components-tab-pane').length;

  let active = 0;
  let timer = setInterval(() => {
    active = interval(
      active,
      length,
      $nav,
      $tabs,
      '.system-components-tab-button'
    );
  }, 5000);

  $nav.find('.system-components-tab-button').on('click', (e) => {
    const $t = $(e.currentTarget);
    const tab = $t.data('tab');
    if (!$t.is('.active')) {
      $nav.find('.active').removeClass('active');
      $t.addClass('active');
      active = $t.index();

      clearInterval(timer);
      timer = setInterval(() => {
        active = interval(
          active,
          length,
          $nav,
          $tabs,
          '.system-components-tab-button'
        );
      }, 5000);

      $tabs.find('.show').removeClass('show');
      $(tab).addClass('show');
    }
  });
}
